export const contact = {
    'meta': {
        'title': 'Kontakt z naszym centrum #cityLocativeIn# | COLLIGO',
        'description': 'Sposoby kontaktu oraz wskazówki dojazdu do Centrum Psychiatrii i Psychoterapii COLLIGO #cityLocativeIn#'
    },
    'url': {
        'address': '#cityIdUrl#/kontakt/',
        'title': 'Kontakt • Psychiatria dzieci i młodzieży, psychiatria osób dorosłych, psychoterapia, psychologia | COLLIGO',
        'name': 'Kontakt'
    },
    'opengraph': {
        'image': {
            'url': null,
            'width': 150,
            'height': 150,
            'alt': 'Psychiatra dziecięcy #cityLocativeIn#. Psychiatra #cityLocativeIn#. Psychoterapia #cityLocativeIn#. Psychologia #cityLocativeIn#. Gabinety w dogodnym miejscu.'
        }
    }
}